import { PlaceholderKey } from './placeholder-keys';
import { DEFAULT_DATE_FORMAT } from './resolver';

/**
 * Default for `player_birth_date`: day and month, no year. The birthday card is
 * a public picture, so printing the year (and with it the age) is left to the
 * designer as an explicit format.
 */
export const DEFAULT_BIRTH_DATE_FORMAT = 'd MMMM';

const DATE_KEYS: ReadonlySet<string> = new Set<string>([PlaceholderKey.MATCH_DATE, PlaceholderKey.PLAYER_BIRTH_DATE]);

/** True for the keys whose text is a date shaped by `data.dateFormat`. */
export function isDateKey(key: string | undefined): boolean {
  return key !== undefined && DATE_KEYS.has(key);
}

/** The format an empty `data.dateFormat` falls back to for the given key. */
export function defaultDateFormatFor(key: string | undefined): string {
  return key === PlaceholderKey.PLAYER_BIRTH_DATE ? DEFAULT_BIRTH_DATE_FORMAT : DEFAULT_DATE_FORMAT;
}
